import { Button, ButtonProps, useDisclosure } from "@chakra-ui/react";
import LoginModal from "../modal/LoginModal";

interface Props extends ButtonProps {
  variant?: string;
}

const ButtonLogin = ({ variant, ...props }: Props) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Button
        variant={!!variant ? variant : "solid"}
        colorScheme="red"
        {...props}
        onClick={onOpen}
      >
        Login
      </Button>

      <LoginModal
        isOpen={isOpen}
        onOpen={onOpen}
        onClose={onClose}
        children={undefined}
      />
    </>
  );
};

export default ButtonLogin;
